<template>
  <div class="brand-editor">
    <el-form ref="form" :model="form" :rules="rules" label-width="125px">
      <el-form-item label="名称（中文）：" prop="brandName">
        <el-input v-model="form.brandName"></el-input>
      </el-form-item>
      <el-form-item label="名称（英文）：" prop="brandNameEnglish">
        <el-input v-model="form.brandNameEnglish"></el-input>
      </el-form-item>
      <el-form-item label="原产国：" prop="brandCountry">
        <el-input v-model="form.brandCountry"></el-input>
      </el-form-item>
      <el-form-item label="排序：" prop="brandSort">
        <el-input v-model="form.brandSort"></el-input>
      </el-form-item>
      <el-form-item label="品牌介绍：" prop="brandDetail">
        <editor
          :editContent="form.brandDetail"
          @getValue="getEditorContent"
        />
      </el-form-item>
      <el-form-item label="图片：" class="uploadImg" prop="brandUrl">
        <upload
          :url="form.brandUrl"
          @successUpload="handleSuccessUpload"
          prompt="上传封面图片：大小不超过2M，支持Jpeg、Jpg、Png格式，建议上传690*300尺寸。"
        />
      </el-form-item>
      <el-form-item class="submit" prop="name">
        <el-button type="primary" :loading="loading"  @click="onSubmit('form')">保存</el-button>
        <el-button @click="$router.push({name: 'Brand'})">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { updateBrand, getBrand } from '@/api/brand';
import Upload from '@/components/Upload/index.vue';
import Editor from '@/components/Editor';
import { validCurrency } from '@/utils/validate';

export default {
  name: 'BrandAdd',
  data() {
    const validNumber = (rule, value, callback) => {
      if (validCurrency(value)) {
        callback();
      } else {
        callback(new Error('请输入正确数字值!'));
      }
    };
    return {
      form: {
        id: '',
        brandName: '',
        brandNameEnglish: '',
        brandCountry: '',
        brandDetail: '',
        brandUrl: '',
        brandSort: '',
      },
      rules: {
        brandName: [
          { required: true, message: '请输入中文名称', trigger: 'blur' },
        ],
        brandNameEnglish: [
          { required: true, message: '请输入英文名称', trigger: 'blur' },
        ],
        brandCountry: [
          { required: true, message: '请选择原产国', trigger: 'blur' },
        ],
        brandSort: [
          { required: true, message: '排序不能为空', trigger: 'blur' },
          { validator: validNumber, trigger: 'blur' },
        ],
      },
      loading: false,
    };
  },
  components: {
    Upload,
    Editor,
  },
  mounted() {
    this.getBrand();
  },
  methods: {
    getBrand() {
      const { id } = this.$route.query;
      getBrand(id).then((res) => {
        if (res.success) {
          Object.keys(this.form).forEach((key) => {
            this.form[key] = res.data[key];
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 编辑品牌
    updateBrand() {
      this.loading = true;
      updateBrand(this.form).then((res) => {
        if (res.success) {
          this.loading = false;
          this.$message.success('编辑成功');
          this.$router.push({ name: 'Brand' });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const { brandDetail, brandUrl } = this.form;
          if (!brandDetail) {
            this.$message.warning('品牌介绍不能为空');
            return false;
          }
          if (!brandUrl) {
            this.$message.warning('请上传图片');
            return false;
          }
          this.updateBrand();
          return true;
        }
        return false;
      });
    },
    handleSuccessUpload(url) {
      this.form.brandUrl = url;
    },
    getEditorContent(value) {
      this.form.brandDetail = value;
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.brand-editor
  .el-form
    width 910px
    margin 0 auto
    .uploadImg
      flex-row()
      >>>.el-form-item__content
        margin-left 0 !important
    .submit
      text-align center
    >>>.el-input__inner
      width 500px !important
</style>
